var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGps({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "62px",
    viewBox: "0 0 48 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6af80ab20c294012ce6660243a47f7c1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nueva-tienda",
    transform: "translate(-525.000000, -17.000000)",
    fill: "#FF671D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6af80ab20c294012ce6660243a47f7c1",
    transform: "translate(525.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.000000, 31.000000) scale(-1, 1) rotate(-180.000000) translate(-24.000000, -31.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8841149,61.8741258 C15.6872907,61.1794747 10.8772421,58.7722366 7.06825993,54.9592475 C3.67891679,51.5663387 1.45179667,47.4465137 0.45073019,42.7123843 C0.0146595637,40.7087777 -0.130065325,36.8635233 0.127785132,34.6505092 C1.17688258,25.7484733 6.09942476,16.0701742 14.7829181,5.8591828 C17.1718267,3.04768058 18.6563628,1.60966426 19.7699229,1.02825774 C22.8849839,-0.619798802 26.6295034,-0.264248791 29.5183133,1.93294905 C31.0515124,3.09639473 35.6188782,8.55744045 38.5241197,12.6930818 C43.5123885,19.802184 46.4498613,26.3298798 47.6923466,33.1315135 C48.1284173,35.4906701 48.095554,40.4342071 47.627884,42.5833234 C46.8853,46.0730278 45.5132575,49.24008 43.6255141,51.9054398 C42.3988284,53.6180268 39.6553754,56.3643659 37.9445882,57.592342 C35.2978291,59.4662551 32.0216115,60.8884551 28.744762,61.5831062 C26.9366488,61.9715541 22.7080277,62.1328802 20.8841149,61.8741258 Z M27.7114642,51.2430539 C32.6182067,49.8214865 36.3462945,45.8629876 37.5085176,40.8865527 C37.8959252,39.1575168 37.8636939,36.3466473 37.4440549,34.6663255 C36.1687064,29.77087 32.3274929,25.8610852 27.5016447,24.5527624 C25.6777319,24.0517026 22.4015143,24.0517026 20.5776015,24.5363134 C15.719522,25.8610852 11.9105398,29.7386048 10.6193916,34.6663255 C10.1510897,36.4757081 10.1510897,39.1739658 10.6029599,41.0807767 C11.8625089,46.2672517 15.9615728,50.2902811 21.20706,51.4530942 C22.8047216,51.8086442 26.1138025,51.6953996 27.7114642,51.2430539 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.369283,44.6027463 C20.1743942,44.037156 18.2215562,42.1790593 17.4947718,39.9337799 C17.0429015,38.5444777 17.204058,36.4276266 17.8499482,35.0225082 C18.8181513,32.9708201 20.6256325,31.5973342 22.9500785,31.1772538 C25.8230888,30.6439288 28.9217182,32.2919853 30.1970667,35.0225082 C30.8587565,36.4282593 31.019913,38.5444777 30.5680428,39.9337799 C29.9708156,41.807693 28.6310044,43.3102397 26.8399549,44.1504006 C25.9684456,44.5540321 25.532375,44.6514604 24.3865836,44.6995419 C23.6117683,44.7324398 22.7080277,44.6837256 22.369283,44.6027463 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.9bd5175280166bcafcd657b8b6b88cee.svg";
export { ForwardRef as ReactComponent };